import {
  Building2,
  KanbanSquare,
  LayoutDashboard,
  Tag,
  Users,
} from 'lucide-react';

export enum AdminTab {
  Offers = 'offers',
  Overview = 'overview',
  Pipeline = 'pipeline',
  Providers = 'providers',
  Users = 'users',
}

export const ADMIN_TAB_KEYS = [
  AdminTab.Overview,
  AdminTab.Users,
  AdminTab.Providers,
  AdminTab.Offers,
  AdminTab.Pipeline,
] as const;

export const isAdminTab = (value: string): value is AdminTab =>
  (ADMIN_TAB_KEYS as readonly string[]).includes(value);

export const ADMIN_TABS = [
  {
    adminOnly: false,
    icon: LayoutDashboard,
    key: AdminTab.Overview,
    labelKey: 'pages.admin.tabs.overview' as const,
  },
  {
    adminOnly: true,
    icon: Users,
    key: AdminTab.Users,
    labelKey: 'pages.admin.tabs.users' as const,
  },
  {
    adminOnly: false,
    icon: Building2,
    key: AdminTab.Providers,
    labelKey: 'pages.admin.tabs.providers' as const,
  },
  {
    adminOnly: false,
    icon: Tag,
    key: AdminTab.Offers,
    labelKey: 'pages.admin.tabs.offers' as const,
  },
  {
    adminOnly: false,
    icon: KanbanSquare,
    key: AdminTab.Pipeline,
    labelKey: 'pages.admin.tabs.pipeline' as const,
  },
] as const;
